export default __webpack_public_path__ + "static/media/logo512.da79592e.png";